/* eslint-disable max-len */
import React from 'react';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';

export const IconMenuClose: React.FC<CommonIconProps> = ({ className }) => (
  <svg viewBox="0 0 20 40" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect y="12" width="11" height="2.5" rx="1.25" />
    <rect y="18.75" width="7" height="2.5" rx="1.25" />
    <path d="M10 20L18.9863 20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15 15L10 20L15 25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <rect y="25.5" width="11" height="2.5" rx="1.25" />
  </svg>
);
